// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"AdminSiteManagement_paginationPageDropdownWrap__BL3NK"};